export const Testing = {
    "共":"共",
    "题":"题",
    "被打回":"被打回",
    "用时":"用时",
    "不限时":"不限时",
    "时":"时",
    "分":"分",
    "请选择":"请选择",
    "匿名":"匿名",
    "实名":"实名",
    "得分":"得分:",
    "回答正确":"回答正确",
    "回答错误":"回答错误",
    "不能大于此题分数":"不能大于此题分数",
    "学生答案":"学生答案：",
    "回答错误得分0":"回答错误, 得分: 0",
    "作答者正确率":"作答者正确率: ",
    "份待批改":"份待批改",
    "还有":"还有",
    "道题未作答":"道题未作答",
    "您只有一次机会提交后不可更改":"您只有一次机会，提交后不可更改",
    "提交成功":"提交成功",
    "您的试卷已经成功提交":"您的试卷已经成功提交",
    "是否直接前往发布测试":"是否直接前往发布测试？",
    "前往发布设置":"前往发布设置",
    "稍后再说":"稍后再说",
    "普通测试":"普通测试",
    "考试":"考试",
    "测试类型":"测试类型",
    "预览试题":"预览试题",
    "测试标题":"测试标题",
    "测试设置":"测试设置",
    "是否同步发送给学生":"是否同步发送给学生",
    "测试详情":"测试详情",
    "开启后在完成添加的同时会将本活动发布给学生":"开启后，在完成添加的同时会将本活动发布给学生",
    "限时答题":"限时答题",
    "不随机":"不随机",
    "按题型抽取":"按题型抽取",
    "按题目区块抽取":"按题目区块抽取",
    "添加测试":"添加测试",
    "是否发布测试":"是否发布测试?",
    "发布中":"发布中...",
    "确认发布":"确认发布",
    "天":"天",
    "0分钟":"0分钟",
    "选":"选",
    "的人":"的人",
    "正确学生":"正确学生",
    "错误学生":"错误学生",
    "查看学生答案":"查看学生答案",
    "确定打回该学生的试卷吗":"确定打回该学生的试卷吗?",
    "打回成功":'打回成功',
    "已经是最后一个学生":"已经是最后一个学生",
    "已经是第一个学生":"已经是第一个学生",
    "您的试卷未提交可以继续作答哦":"您的试卷未提交，可以继续作答哦！",
    "您的测试已被老师打回了需要重新提交才算成绩哦":"您的测试已被老师打回了，需要重新提交才算成绩哦！",
    "点击下方查看试卷可以查看作答情况":"点击下方“查看试卷”可以查看作答情况",
    "等待老师批改点击下方查看试卷可以查看作答情况":"等待老师批改，点击下方“查看试卷”可以查看作答情况",
    "成绩未公布请您耐心等待":"成绩未公布，请您耐心等待！",
    "测试已结束点击下方查看试卷可以查看试卷":"测试已结束，点击下方“查看试卷”可以查看试卷",
    "本试卷共":"本试卷共",
    "本场考试已开启防切屏模式切换页面":"本场考试已开启防切屏模式, 切换页面",
    "次后将强制交卷请谨慎答题勿退出答题页面":"次后将强制交卷, 请谨慎答题勿退出答题页面!",
    "线下测试":"线下测试",
    "查看试卷":"查看试卷",
    "重新答题":"重新答题",
    "继续答题":"继续答题",
    "成绩不公布":"成绩不公布",
    "测试已结束未参与":"测试已结束, 未参与!",
    "我的作答":"我的作答",
    "测试已结束系统已自动收取试卷":"测试已结束，系统已自动收取试卷",
    "您已跳出答题页面":"您已跳出答题页面",
    "次系统将在":"次, 系统将在",
    "后自动交卷":"后自动交卷!",
    "次再跳出":"次, 再跳出",
    "次将":"次将",
    "自动交卷":"自动交卷",
    "请谨慎答题":",请谨慎答题!",
    "15秒后系统将自动交卷":"15秒后, 系统将自动交卷!",
    "答题过程中不允许回退":"答题过程中不允许回退",
    "您的网络出现问题答案保存失败请检查当前网络是否有问题恢复网络后请重新答题":"您的网络出现问题，答案保存失败！请检查当前网络是否有问题，恢复网络后请重新答题",
    "确定提交当前试卷":'确定提交当前试卷？',
    "您是否进行返回当前返回将被记录为切屏":"您是否进行返回？当前返回将被记录为切屏",
    "1次":"1次",
    "放弃返回":"放弃返回",
    "继续返回":"继续返回",
    "客观题":"客观题",
    "正确":"正确",
    "错误":"错误",
    "主观题":"主观题",
    "全部解析":"全部解析",
    "错题解析":"错题解析",
    "试卷还未批改暂无数据分析":"试卷还未批改，暂无数据分析",
    "请确认是否要":"请确认是否要",
    "打回后学生需要重新提交":"打回后, 学生需要重新提交",
    "催交的学生将会受到催交信息":"催交的学生将会受到催交信息",
    "确认催交":"确认催交",
    "待批":"待批",
    "批阅状态":'批阅状态',
    "删除测试":'删除测试',
    "确定要删除测试吗":"确定要删除测试吗?",
    "抽题测试":"抽题测试",
    "题目顺序随机打乱":"题目顺序随机打乱",
    "选项顺序随机打乱":"选项顺序随机打乱",
    "答案公布设置":"答案公布设置",
    "成绩公布设置":"成绩公布设置",
    "交卷后允许查看试卷":'交卷后允许查看试卷',
    "多选题计分方式":"多选题计分方式",
    "填空题计分方式":"填空题计分方式",
    "填空题大小写敏感":"填空题大小写敏感",
    "允许复制试题":"允许复制试题",
    "允许粘贴答案":"允许粘贴答案", 
    "答案展示样式":"答案展示样式",
    "答题过程可以回退":"答题过程可以回退",
    "目前该测试考试正在进行中无法进行切屏设置":"目前该测试(考试)正在进行中,无法进行切屏设置",
    "切屏后强制交卷":"切屏后强制交卷",
    "切屏次数":"切屏次数",
    "学生切屏页面超过后将强制交卷":"学生切屏页面超过后将强制交卷",
    "请输入次数":"请输入次数",
    "当学生在当前设备上每离开一次答题界面将给予提示如果切换页面超出上限后将被强制交卷":"当学生在当前设备上，每离开一次答题界面，将给予提示，如果切换页面超出上限后将被强制交卷。",
    "注设置次数时请考虑设备及网络等异常情况例如手机端会存在电话呼入电脑端广告弹框不小心无操作切出等":"注：设置次数时请考虑设备及网络等异常情况，例如：手机端会存在电话呼入，电脑端广告弹框，不小心无操作切出等；",
    "特别注意电脑端作答文件题时上传图片算作1次切屏手机端由于不同的操作系统会导致切换到手机桌面其他应用或者文件题上传图片时会每5秒记一次切屏":"特别注意：电脑端作答文件题时，上传图片算作1次切屏；手机端由于不同的操作系统，会导致切换到手机桌面、其他应用或者文件题上传图片时会每5秒记一次切屏！",
    "允许多设备作答":"允许多设备作答",
    "不随机打乱":"不随机打乱",
    "全题目顺序随机打乱":"全题目顺序随机打乱",
    "同一题型内题目顺序随机打乱":"同一题型内题目顺序随机打乱",
    "不公布":"不公布",
    "学生交卷后公布答案":"学生交卷后公布答案",
    "到截止时间公布答案":"到截止时间公布答案",
    "成绩出来之后立即看到":"成绩出来之后立即看到",
    "多选少选错选不得分":"多选、少选、错选不得分",
    "少选时按照选项个数计分":"少选时，按照选项个数计分",
    "少选时得一半分数":"少选时，得一半分数",
    "与答案不全匹配时手动批改":"与答案不全匹配时，手动批改",
    "与答案不全匹配时机器自动批改":"与答案不全匹配时，机器自动批改",
    "与答案不全匹配时自动0分":"与答案不全匹配时，自动0分",
    "不敏感":"不敏感",
    "大小写敏感":"大小写敏感",
    "一页式":"一页式",
    "单题卡片式":"单题卡片式",
    "目前该测试考试正在进行中若更改设置可能影响学生的答题数据":"目前该测试(考试)正在进行中,若更改设置可能影响学生的答题数据",
    "确定更改":"确定更改",
    "目前该测试考试已结束若更改设置可能影响学生的答题结果":"目前该测试(考试)已结束,若更改设置可能影响学生的答题结果",
    "当前设置为一页式答题过程可以回退设置无效":"当前设置为一页式，答题过程可以回退设置无效!",
    "请输入0100之间的整数":"请输入0~100之间的整数",
    "随机抽取试题":"随机抽取试题",
    "题目数量":"题目数量",
    "最多可选":"最多可选",
    "每张试卷":"每张试卷",
    "从第":"从第",
    "题第":"题~第",
    "题抽取":"题 抽取",
    "增加抽取范围":"增加抽取范围",
    "随机抽取的题目个数不能全部为0":"随机抽取的题目个数不能全部为0",
    "没有该题":"没有该题",
    "最多抽取":"最多抽取",
    "测试未开始":"测试未开始",
    "距离开始还剩":"距离开始还剩",
    "测试进行中":"测试进行中",
    "建议不要修改测试参数以免影响学生答题数据":"建议不要修改测试参数，以免影响学生答题数据！",
    "请确认是否结束该测试":"请确认是否结束该测试",
    "批阅测试":"批阅测试",
    "测试分析":"测试分析",
    "手动结束测试":"手动结束测试",
}